/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AppClaimBackendService } from './services/app-claim-backend.service';
import { AppAdministrationBackendService } from './services/app-administration-backend.service';
import { IdentityBackendService } from './services/identity-backend.service';
import { SubscriptionBackendService } from './services/subscription-backend.service';
import { BookingBackendService } from './services/booking-backend.service';
import { AppOrderBackendService } from './services/app-order-backend.service';
import { PostBackendService } from './services/post-backend.service';
import { AppReportBackendService } from './services/app-report-backend.service';
import { SamplesBackendService } from './services/samples-backend.service';
import { TelemetryBackendService } from './services/telemetry-backend.service';
import { ProductBackendService } from './services/product-backend.service';
import { AppInvoicesBackendService } from './services/app-invoices-backend.service';
import { MasterBackendService } from './services/master-backend.service';
import { FakesBackendService } from './services/fakes-backend.service';
import { LoyaltyBackendService } from './services/loyalty-backend.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AppClaimBackendService,
    AppAdministrationBackendService,
    IdentityBackendService,
    SubscriptionBackendService,
    BookingBackendService,
    AppOrderBackendService,
    PostBackendService,
    AppReportBackendService,
    SamplesBackendService,
    TelemetryBackendService,
    ProductBackendService,
    AppInvoicesBackendService,
    MasterBackendService,
    FakesBackendService,
    LoyaltyBackendService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
